import { API_LOCATION_URL } from 'infrastructure/config';
import { ICompanyUserLogoutClient, IPostInput } from 'interfaceAdapter/gatewaySchemas/ICompanyUserLogoutClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/company/user/logout`;

export class CompanyUserLogoutClient implements ICompanyUserLogoutClient {
    async post(input: IPostInput): Promise<void> {
        const { token } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-C': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }

        await fetch(PATH, { method, headers });
    }
}
